// extracted by mini-css-extract-plugin
export default {"footerRow":"Footer_footerRow__WKYff","poweredBy":"Footer_poweredBy__uLaJX","logoWrapper":"Footer_logoWrapper__q1VDv","logo":"Footer_logo__8ZF21"};